/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */

/** @module react/plugins/input-presets/auto-capitalize-preset */
import { Types } from '@codistica/types';
import { capitalizeFirstsFilter } from '../../input-filters/internals/capitalize-firsts-filter.js';
import { uppercaseFilter } from '../../input-filters/internals/uppercase-filter.js';
var autoCapitalizePresetSchema = new Types({
  options: {
    type: 'Object',
    def: {
      errorMessages: {
        type: 'Object',
        def: {}
      }
    }
  }
});
/**
 * @typedef autoCapitalizePresetErrorMessagesType
 * @property {(string|(function(*): string|null)|Object<string,*>|null)} [generic=null] - Generic error message.
 */

/**
 * @typedef autoCapitalizePresetOptionsType
 */

/**
 * @description Auto capitalize preset.
 * @param {autoCapitalizePresetOptionsType} [options] - Preset options.
 * @returns {{type: 'preset', name: string, groupErrorMessages: Array<string>, plugin: Array<*>}} Preset.
 */

function autoCapitalizePreset(options) {
  var _autoCapitalizePreset = autoCapitalizePresetSchema.validate({
    options: options
  });

  options = _autoCapitalizePreset.options;
  return {
    type: 'preset',
    name: 'autoCapitalizePreset',
    groupErrorMessages: {},
    plugin: [uppercaseFilter, capitalizeFirstsFilter]
  };
}

export { autoCapitalizePreset };